/**
 * /* eslint-disable
 *
 * @format
 */

import { createGlobalStyle } from "styled-components"
import { normalize } from "polished"

import poppins200Ttf from "../fonts/Poppins-ExtraLight.ttf"
import poppins200Woff from "../fonts/Poppins-ExtraLight.woff"
import poppins200Eot from "../fonts/Poppins-ExtraLight.eot"
import poppins200Svg from "../fonts/Poppins-ExtraLight.svg"

import poppins400Ttf from "../fonts/Poppins-Regular.ttf"
import poppins400Woff from "../fonts/Poppins-Regular.woff"
import poppins400Eot from "../fonts/Poppins-Regular.eot"
import poppins400Svg from "../fonts/Poppins-Regular.svg"

import poppins700Ttf from "../fonts/Poppins-Bold.ttf"
import poppins700Woff from "../fonts/Poppins-Bold.woff"
import poppins700Eot from "../fonts/Poppins-Bold.eot"
import poppins700Svg from "../fonts/Poppins-Bold.svg"

import poppins600Ttf from "../fonts/Poppins-SemiBold.ttf"
import poppins600Woff from "../fonts/Poppins-SemiBold.woff"
import poppins600Eot from "../fonts/Poppins-SemiBold.eot"
import poppins600Svg from "../fonts/Poppins-SemiBold.svg"

function fontFace(
  name,
  eotPath,
  svgPath,
  ttfPath,
  woffPath,
  fontWeight = "normal",
  fontStyle = "normal"
) {
  // const fontPath = `${appPath}/ui-lib/assets/fonts`
  return `
    @font-face{
      font-family: "${name}";
      src: url("${eotPath}");
      src: url("${eotPath}?#iefix") format("embedded-opentype"),
        url("${woffPath}") format("woff"),
        url("${ttfPath}") format("truetype"),
        url("${svgPath}") format("svg");
      font-style: ${fontStyle};
      font-weight: ${fontWeight};
    }
  `
}

const GlobalStyle = createGlobalStyle`
  ${normalize()}
  ${fontFace(
    "Poppins",
    poppins400Eot,
    poppins400Svg,
    poppins400Ttf,
    poppins400Woff,
    "400",
    "normal"
  )}
  ${fontFace(
    "Poppins",
    poppins200Eot,
    poppins200Svg,
    poppins200Ttf,
    poppins200Woff,
    "200",
    "normal"
  )}
  ${fontFace(
    "Poppins",
    poppins700Eot,
    poppins700Svg,
    poppins700Ttf,
    poppins700Woff,
    "700",
    "normal"
  )}
  ${fontFace(
    "Poppins",
    poppins600Eot,
    poppins600Svg,
    poppins600Ttf,
    poppins600Woff,
    "600",
    "normal"
  )}
  html {
    box-sizing: border-box;
    font-size: 16px;
    height: 100%;
  }
  *, *:before, *:after {
    box-sizing: inherit;
  }
  body {
    font-family: "Poppins", sans-serif;
    height: 100vh;
    color: #fff;
  }
  #root {
    height: 100%;
  }
  button, input, optgroup, select, textarea {
    font-family: "Poppins", sans-serif;
  }
`

export default GlobalStyle
